<template>
  <div class="px-2 px-sm-10">
    <div
      class="text-h6 text-sm-h4 my-4 d-flex justify-space-between align-center"
    >
      Сессия
    </div>
    <v-card class="pa-5">
      <div v-if="loading" class="text-center pa-4">Загрузка...</div>
      <div v-else-if="error" class="text-center pa-4 red--text">
        {{ error }}
      </div>
      <object-grid
        v-else
        :content_type="'products'"
        :value="visitsForGrid"
        :show-actions="{ edit: true }"
        :field-defs="[
          { text: 'Сессия', value: 'product_name' },
          { text: 'Дата', value: 'prescribed_at' },
          { text: 'Действия', value: 'actions', sortable: false },
        ]"
        @doEditItem="showSessionDialog"
      />
    </v-card>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import SessionForm from "@/components/SessionForm";
import ObjectGrid from "@/components/ObjectGrid";
import ApiService from "@/api/ApiService";

export default {
  name: "SessionByUrlView",
  components: { ObjectGrid },
  props: ["visit_uuid"],

  data() {
    return {
      visit: null,
      loading: true,
      error: null,
      pollInterval: undefined,
      modalOpen: false,
    };
  },

  computed: {
    visitsForGrid() {
      if (!this.visit) return [];
      return [
        {
          ...this.visit,
          viewProgress: this.visit.view_progress,
        },
      ];
    },
  },

  methods: {
    ...mapActions("modals", ["showModalForm", "closeModalForm"]),

    async loadVisit() {
      if (!this.visit_uuid) {
        this.error = "Ссылка некорректна";
        this.loading = false;
        return;
      }
      try {
        const res = await ApiService.get(
          `v1/patients/visits/${this.visit_uuid}`
        );
        if (!res?.data) {
          this.error = "Сессия не найдена";
        } else if (res.data.status !== "active") {
          this.error = "Сессия больше недоступна";
          this.visit = null;
        } else {
          this.visit = res.data;
          this.error = null;
        }
      } catch (e) {
        if (e?.response?.status === 404) {
          this.error = "Сессия не найдена";
        } else {
          console.error("loadVisit:", e);
          this.error = "Не удалось загрузить сессию";
        }
      } finally {
        this.loading = false;
      }
    },

    showSessionDialog(item) {
      this.modalOpen = true;
      this.startPolling();
      this.showModalForm({
        title: item.product_name,
        component: SessionForm,
        width: this.$vuetify.breakpoint.smAndUp ? "50%" : "80%",
        item,
        patient_id: undefined,
      }).finally(() => {
        this.modalOpen = false;
        this.stopPolling();
      });
    },

    startPolling() {
      this.stopPolling();
      this.pollInterval = setInterval(async () => {
        await this.loadVisit();
        if (!this.visit && this.modalOpen) {
          this.closeModalForm();
        }
      }, 10000);
    },

    stopPolling() {
      if (this.pollInterval) {
        clearInterval(this.pollInterval);
        this.pollInterval = undefined;
      }
    },
  },

  beforeMount() {
    this.loadVisit();
  },

  beforeDestroy() {
    this.stopPolling();
  },
};
</script>
